import remote from './remote';

export function getProducts(query) {
  return remote.get('gift_store/products', query);
}

export function getPurchases(query) {
  return remote.get('gift_store/purchases', query);
}

export function purchaseProduct(id) {
  return remote.post(`gift_store/products/${id}/purchases`);
}
